{
  "addToContacts": "Add to contacts",
  "addToResourceBase": "Add to resource base",
  "areYouSureClose": "Are you sure you want to close",
  "backToOpportunities": "Back to inquiries",
  "board.minimizeColumn": "Minimize column",
  "button.addService": "Add service",
  "button.Forward": "Forward",
  "button.RecommendService": "Recommend service",
  "button.RegisterService": "Register service",
  "actionbar.StartEmailThread": "Send new email",
  "actionbar.RecommendService": "Recommend service",
  "actionbar.DeliverService": "Deliver service",
  "actionbar.AddNote": "Add note",
  "actionbar.ProgramAdmission": "Admit to program",
  "actionbar.Refer": "Refer",
  "card.ReadNoteFrom": "Read the note from {{collaborator}} under the activity log tab",
  "chooseForwardRecipient": "Choose who to send the inquiry to",
  "chooseMunicipality": "Choose municipality",
  "chooseProviderType": "Choose provider type",
  "chooseRecommendedServices": "Choose which services to recommend",
  "chooseRegisterServices": "Choose which services to register",
  "chosenServices.plural": "chosen services",
  "chosenServices.singular": "chosen service",
  "chooseServiceType": "Choose service type",
  "closeReason.Other": "Other",
  "closeReason.SentInError": "Referred wrongly",
  "collaboration.AlreadySharedWithAll": "You have shared this inquiry with all actors.",
  "collaboration.BeginCollaboration": "Begin collaboration",
  "collaboration.InCollaborationCheckLog": "In collaboration with {{collaborationActors}}. Check activity log.",
  "collaboration.IntroText": "You may begin a collaboration with other actors. They will have access to it once the inquiry is shared. The note will be shown under the tab \"Activity log\".",
  "collaboration.toast.Error": "Could not begin collaboration. Please try again.",
  "collaboration.toast.Pending": "Beginning collaboration...",
  "collaboration.toast.Success": "The collaboration has begun.",
  "closedOpportunitiesFoundInArchive": "Closed opportunities are found in the archive.",
  "contactAlreadyExists": "The contact already exists in the resource base.",
  "countyView.NoteOpportunitiesCanOnlyBeHandled": "Opportunities can only be handled in the municipality view.",
  "countyWarning": "To help us direct customers to the right prosecutor, we have created a page to collect feedback. To report a correct/incorrect referral, please go to",
  "customerInformation.GoToContact": "Go to contact",
  "customerInformation.GoToMember": "Go to member",
  "customerInformation.Info.AddedContact": "You added {{contactName}} to the resource base.",
  "customerInformation.Info.AddedContactAndMember": "You added {{contactName}} with {{memberName}} to the resource base.",
  "customerInformation.PostError": "Something went wrong with adding to the resource base. Please try again and contact us if the problem persists.",
  "details.Archived.Message": "If further work is needed, the inquiry may be reopened. By reopening the inquiry, you will be assigned as the current advisor.",
  "details.AddNote.Error.Title": "An error has occurred",
  "details.AddNote.Error.Message": "The note could not be saved. Try again or contact us at",
  "details.AddNode.Intro": "All notes are saved in the activity log and are visible to other actors",
  "details.AddNote.Required": "Please add a note",
  "details.AddNote.Success.Message": "The note has been saved",
  "details.Referral.Header": "Referral to other providers",
  "details.Referral.NoneChosen": "At least one provider must be selected to refer the inquiry to.",
  "details.Referral.ReferToSelectedProviders": "The inquiry will be referred to the following providers:",
  "details.Referral.Actor.TextAreaField.Required": "Message to actor *",
  "details.Referral.Actor.TextAreaField.errorMessage": "Please write a message to recipients. The actors will be notified of the inquiry via e-mail.",
  "details.Referral.Actor.QueryData.isError": "Something went wrong the inquiry. ",
  "details.Referral.Actor.QueryData.isSuccess": "Inquiries are forwarded.",
  "details.Referral.Table.RowSelectedText_zero": "You have to choose an actor to refer the opportunity",
  "details.Referral.Table.RowSelectedText_one": "{{count}} actor chosen",
  "details.Referral.Table.RowSelectedText_other": "{{count}} actors chosen",
  "details.Referral.Table.RowSelectedText": "actor chosen",
  "details.Referral.Table.RowsSelectedText": "actors chosen",
  "details.Title.ActivityLog": "Activity log",
  "details.Title.Archiving": "Archiving",
  "details.Title.Inquiry": "Inquiry",
  "details.Title.Referrer": "Referrer",
  "details.Title.Services": "Services",
  "details.Title.CompanyInfo": "Company info",
  "companyInfo.viewInCustomerRegistry": "View in customer registry",
  "details.Title.CustomerFollowUp": "Customer follow up",
  "details.Title.CustomerCommunication": "E-mail to customer",
  "documentTitleOpportunities": "Inquiries - Multicompanyportal",
  "documentTitleOpportunityDetails": "Inquiry details - Multicompanyportal",
  "doYouWantToAddOrganizationAsLead": "Do you want to add the organization as a lead?",
  "doYouWantToResumeOpportunity": "Do you want to resume this inquiry?",
  "errorCommentEmpty": "You need to add a note.",
  "errorCouldNotGetAllForms": "Could not retrieve the opportunities.",
  "errorCouldNotGetForm": "Could not get the form.",
  "errorErrorBoundaryCouldNotShow": "Display of inquiry failed. Please contact us if this happens.",
  "errorINResponse": "Could not get email response from Innovation Norway.",
  "errorNoCounties": "No counties registered.",
  "explanation.AddComment": "Here you may add a note to the Activitylog. This could be a meetind held, things to consider going forward or other things.",
  "explanation.Close1": "If you are done handling the inquiry, it cannot be forwarded or for some other reason cannot be completed, you may choose to end it.",
  "explanation.Close2": " It will still show up in the archive and you may choose to reopen it at a later point. Give a reason for why the inquiry is ended.",
  "explanation.CustomerInformation": "Here you find the information about the customer and the company which submitted the inquiry. You may choose to add in both company and customer to your resource base so you can easily find them again later.",
  "explanation.Forward": "Here you choose the recipient of this inquiry among the other One Way In pilot actors. When an inquiry is forwarded it is closed to you, but you may still see it in the archive. The commented reason will be shown to the recipient.",
  "explanation.RegisterServices": "Here you select which services you have offered the customer as part of working on the inquiry. These will be added to the activitylog.",
  "explanation.Reopen": "If you want you can choose to reopen an inquiry. Give a reason for why you are handling this inquiry again.",
  "feedbackFilter.Correct": "Correct",
  "feedbackFilter.Incorrect": "Incorrect",
  "feedbackFilter.Missing": "Missing",
  "feedbackFilter.Title": "Filter by feedback",
  "feedbackFromOtherActors": "Feedback from other actors",
  "feedbacks": "Feedbacks",
  "feedback.sendWithoutSuggestion": "Send without suggestions",
  "opportunity.feedback.intro.1": "Before contacting the client - give us a quick answer",
  "opportunity.feedback.intro.2": "Was One Way In correct in sending this referral to you?",
  "opportunity.feedback.intro.3": "Your answers help you get more relevant referrals. It will not affect the referral itself.",
  "opportunity.feedback.incorrect": "Please tell us why you should not have received this referral",
  "opportunity.feedback.option.geography": "Wrong geographical area",
  "opportunity.feedback.option.tooFar": "The company/The founder is too far along",
  "opportunity.feedback.option.tooShort": "The company/The founder hasn't gotten far enough",
  "opportunity.feedback.option.notEnoughInnovation": "Too low innovation degree",
  "opportunity.feedback.option.wrongBusiness": "Wrong industry",
  "opportunity.feedback.option.other": "Other",
  "opportunity.feedback.confirmation": "Please help us by referring this opportunity to other relevant actors if possible.",
  "filterByMunicipality": "Filter by municipality",
  "fromMunicipality": "From municipality",
  "fullHistoric": "Full historic",
  "getMoreOpportunities": "Get more opportunities",
  "history.automaticReply": "Automatic reply",
  "history.readEmail": "Read email",
  "history.readAutomaticReply": "Read Automatic reply",
  "history.readReply": "Read reply",
  "history.sentToCustomer": "Sent to the customer",
  "history.sentToCustomerWithReply": "from customer in \"E-mail to customer\"",
  "history.sentToCustomerWithoutReply": "in \"E-mail to customer\"",
  "isUnderDevelopment": "is under development.",
  "missingOpportunityInfo": "Missing information about the inquiry.",
  "municipalityFirstLineFor": "Municipality's first line for",
  "noCustomer": "No customer on the inquiry.",
  "noHistoryFound": "No history found.",
  "noServicesAvailable": "No services available.",
  "noteToActor": "Note to actor",
  "onboarding.modal.header": "Get started with the multicompany portal",
  "onboarding.modal.paragraph1": "Complete three steps to get the most out of the portal",
  "onboarding.modal.paragraph2": "Follow the steps in the panel on the righthand side",
  "onboarding.modal.skip": "Skip",
  "opportunities": "Opportunities",
  "opportunities.getMoreOpportunities": "Getting more opportunities...",
  "opportunities.newOpportunities": "There are {{ numberOfOpportunities }} new opportunities.",
  "opportunities.newOpportunity": "There is one new enquiry",
  "opportunityDetails.And": "and",
  "opportunityDetails.Contract": "Contract",
  "opportunityDetails.Phase": "Phase",
  "opportunityDetails.AdmissionDate": "Admission date",
  "opportunityDetails.RegisteredDate": "Registration date",
  "opportunityDetails.Advisor": "Advisor",
  "opportunityDetails.ClosedService": "Closed service.",
  "opportunityDetails.CreationError": "Could not get or create inquiry.",
  "opportunityDetails.ForwardedTo": "Forwarded to",
  "opportunityDetails.ReferredFrom": "Referred from",
  "opportunityDetails.ActorsWhoReferredToYou": "Actors who referred to you",
  "opportunityDetails.FirstLineServiceFor": "First line service for {{municipality}}",
  "opportunityDetails.FoundNoOpportunities": "Found no opportunities.",
  "opportunityDetails.MunicipalitiesList": "All opportunities from:",
  "opportunityDetails.NoRegisteredMunicipalities": "No registered municipalities.",
  "opportunityDetails.OtherServices": "other services",
  "opportunityDetails.RecommendedServices": "Recommended services",
  "opportunityDetails.RegisteredServices": "Registered services",
  "opportunityDetails.ResumedService": "Resumed service.",
  "opportunityDetails.AccessTo": "These have access to the opportunity:",
  "opportunityDetails.CompanyMissing": "Company missing",
  "opportunityDetails.NameMissing": "Name missing",
  "opportunityDetails.MunicipalityMissing": "Municipality missing",
  "opportunityDetails.PhoneMissing": "Phone number missing",
  "opportunityDetails.EmailMissing": "Email missing",
  "opportunityDetails.Concept": "The concept",
  "opportunityDetails.WhatCustomerNeedsHelpWith": "What the customer needs help with",
  "opportunityDetails.ShowInCustomerRegister": "Show in customer registry",
  "opportunityDetails.OtherOpportunitiesFrom": "Other inquiries from {{name}}",
  "opportunityDetails.NoOtherOpportunities": "{{name}} has no other registered inquiries",
  "opportunityDetails.ActorsWithAccess": "Actors with access to the inquiry",
  "organizationAlreadyExists": "Organization is already in the resource base.",
  "recommendToast.Error": "Could not send recommendation. Please try again and contact us if the problem persists.",
  "recommendToast.Pending": "Sending recommendation...",
  "recommendToast.Success": "Recommendation sent!",
  "retrievingFromBrreg": "Retrieving from BrReg...",
  "opportunitySearchInputPlaceHolder": "Search for opportunity, name or municipality",
  "actorSearchInputPlaceHolder": "Search for actor by name, county or municipality",
  "serviceSearchInputPlaceHolder": "Search for service name, actor name or contact person",
  "providerType": "Providertype",
  "sentTo": "Referred to",
  "serviceType": "Type of service",
  "services.Displaying": "Displaying",
  "services.OfTotal": "of a total of",
  "services.NoRecommendedOrRegisteredServices": "You have not registered or recommended any services yet.",
  "services.recommend.error.chooseOneService": "You must select at least one service.",
  "services.recommend.mailpage.actor.description": "Auto-generated email sent to actor",
  "services.recommend.mailpage.actor.title": "You have received an inquiry on Multicompany portal",
  "services.recommend.mailpage.customer.description": "Auto-generated email sent to customer",
  "services.recommend.mailpage.customer.title": "We recommend these services",
  "services.recommend.note.cannotSendToCustomerWarning": "No customer found on inquiry so cannot send them an email.",
  "services.recommend.note.informCustomer": "Do you wish to inform the customer about the recommended services?",
  "services.recommend.note.noteToActor": "Note to actor",
  "services.recommend.note.noteToActorDescription": "The actors who provide the services get an email and access to the inquiry when you recommend services. The note is shown in the Activitylog.",
  "services.recommend.note.noteToCustomer": "Note to customer",
  "services.recommend.note.noteToCustomerDescription": "If you wish you can send an email to the customer with the information about the recommended services. The note to the customer shows in the beginning of the email and you can see a preview of the email in the next step.",
  "services.recommend.result.header": "Email is sent and collaboration begun",
  "services.recommend.result.text1": "The inquiry is shared with the actor and collaboration begun.",
  "services.recommend.result.text2": "We recommend to either continue the collaboration or close the inquiry. You find the options in the toolbar when you close the window.",
  "services.recommend.steps.choose": "Choose service",
  "services.recommend.steps.chooseExplanation": "You find the services you offer under Add service or Add note.",
  "services.recommend.steps.preview": "Preview",
  "services.recommend.steps.writeNote": "Write note",
  "services.recommend.success": "Service recommended",
  "services.recommend.error": "Could not recommend service.",
  "services.register.deliveredService": "Delivered service",
  "services.register.deliveredServices": "Delivered services",
  "services.register.deliveredServiceInfobox": "Register the service in the Common servicecatalogue if you cannot find the service here.",
  "services.register.goToCommunityCatalogue": "Go to the Common servicecatalogue",
  "services.register.noRegisteredServices": "There are no registered services.",
  "services.edit.unpublished": "Sevice unpublished",
  "services.edit.draftDeleted": "Draft deleted",
  "services.edit.serviceDeleted": "Service deleted",
  "services.edit.edit": "Edit service",
  "services.edit.unpublish": "Unpublish service",
  "services.edit.delete": "Delete service",
  "services.edit.deleteDraft": "Delete draft",
  "services.edit.editOrPublish": "Edit and/or publish service",
  "services.edit.unpublishWarning": "The service will be set to draft. You can publish it again later.",
  "services.edit.deleteWarning": "The service will be permanently deleted.",
  "services.edit.deleteDraftWarning": "The draft will be permanently deleted.",
  "status.Active": "Active",
  "status.Archived": "Archived",
  "status.Closed": "Closed",
  "status.Forwarded": "Forwarded",
  "status.New": "New",
  "status.Opened": "Opened",
  "status.Received": "Received",
  "status.Referred": "Referred",
  "status.ReOpened": "Resumed",
  "status.Shared": "Shared",
  "status.FollowUpLater": "Waiting",
  "status.wip": "Work in progress",
  "status.AutoArchived": "Automatically archived",
  "status.EmailReceivedFromCustomer": "Reply",
  "status.EmailSentToCustomer": "Customer contacted",
  "status.ReferredLater": "New referral from IN",
  "success.addService": "Services have been added to the activity log",
  "success.Comment": "The note has been added to the activity log",
  "tabs.Interplay": "Interplay",
  "tabs.Log": "Activitylog",
  "tabs.OneWayIn": "Inquiry",
  "tabs.Services": "Services",
  "tabs.actor": "Actor",
  "tabs.greenPlatform": "Green platform",
  "thisOpportunity": "this inquiry",
  "updateToast.Error": "Error on updating inquiry. Please try again.",
  "updateToast.Pending": "Updating inquiry...",
  "updateToast.Success": "Inquiry updated!",
  "reason": "Reason",
  "feedback.description": "Explain why the inquiry is referred wrong",
  "feedback.sentCorrectly": "Is this inquiry referred correctly?",
  "goToMunicipalityView": "Go to municipality view",
  "goToCountyView": "County view",
  "noRegisteredCounties": "No registered counties",
  "log.table.column.activity": "Activity",
  "log.table.column.actor": "Actor",
  "log.table.column.behandler": "Handlers name",
  "log.table.column.description": "Description",
  "services.recommended": "Recommended services",
  "services.delivered": "Delivered services",
  "tab.Form": "Form",
  "tab.INResponseMail": "Response from Innovation Norway",
  "selectMunicipality": "Select municipality",
  "selectStatus": "Select status",
  "noOpportunitiesFoundTitle": "No one way in -  inquiries",
  "noOpportunitiesFoundDescription": "There are no inquiries for you yet. You may encourage persons and companies to log on to Innovationnorway.no and use the service \"Find out if you can get help\". This will increase the chances of receiving new inquiries. ",
  "noOpportunitiesFoundContactInfo": "If you have questions or feedback, please email us at <1>{{email}}</1>",
  "municipalityFirstLine": "Municipality First Line",
  "addOpportunities.banner": "You can now add Opportunities in Flerbedriftsportalen. Click here to generate a link to the En Vei Inn form that you can send to your customer.",
  "addOpportunities.cta": "Create a link to the En Vei Inn form",
  "addOpportunities.header": "Have the customer create an Opportunity",
  "addOpportunities.main": "Here you can create a link to share with your customer. The link takes the customer til the form for One Way In opportunities. The customer signs in with BankID and submits the form. Within about 2 working days the customer will receive a response from Innovation Norway, and the opportunity will be forwarded to you.",
  "addOpportunities.seeMore.1": "Purpose",
  "addOpportunities.seeMore.2": "We are exploring ways to collect more of your opportunities in Flerbedriftsportalen. Currently we will use the One Way In form for this purpose.",
  "addOpportunities.seeMore.3": "Future process",
  "addOpportunities.seeMore.4": "We are working on a concept that will allow opportunities to be referred to you immediately. An e-mail can be sent to the customer to fill out the form. We want to test out solutions like this upon receiving insights and feedback from you.",
  "addOpportunities.referBack": "Do you want the customer to be referred <strong>back to you</strong> after completing the form?",
  "addOpportunities.error": "Something went wrong. Please try again later.",
  "addOpportunities.submit": "Create link",
  "opportunity.update.error": "Failed to update",
  "status.setFollowUpLater": "Set to Waiting",
  "status.setFollowUpLater.title": "Sett henvendelsen på vent",
  "status.setFollowUpLater.more": "You can re-open the opportunity later. Write a note with the reason for this. The note can be seen in the Activity log.",
  "status.setFollowUpLater.reminder": "Remind me later via e-mail.",
  "status.setActive": "Set work in progress",
  "status.setActive.title": "Set the opportunity to work in progress",
  "status.setActive.more": "The opportunity will be reopened for further work. Write a note with the reason for this. The note can be seen in the Activity log.",
  "status.updateSuccess": "The status has been updated.",
  "opportunity.correctlyReferred": "Was OWI correct in referring this opportunity to you?",
  "opportunity.feedback.doYouWantToGoToReferral": "Do you want to go to the referral page?",
  "opportunity.feedback.comment": "Please tell us why these actors should have received this referral",
  "opportunity.feedback.wrongComment": "Please tell us why referring to you was incorrect",
  "opportunity.feedback.goToReferral": "Go to referral",
  "opportunity.feedback.selectedActors": "You selected: ",
  "referral.title": "Referral",
  "referral.error.text": "Please try again later. If the error persists, please contact us.",
  "referral.notification.step1.error.noneSelected": "You need to select one actor to refer the opportunity",
  "referral.notification.step2.error.noActorMessage": "Message to actor must be filled out.",
  "referral.notification.step2.error.noCustomerMessage": "Message to customer must be filled out.",
  "referral.notification.step3.error": "We could not refer the opportunity. Try again and if the problem persists contact us at ",
  "referral.notification.step3.error.receiverAlreadyHasCustomer": "The referral was not sent because the recipient already has the customer. If you still want to refer to them, you can add services to the referral.",
  "referral.steps.step1.text": "Step 1: Choose actor",
  "referral.steps.step2.text": "Step 2: Write referral",
  "referral.steps.step3.text": "Step 3: Send referral",
  "referral.navigationBar.step": "Step {{currentStep}} of {{stepCount}}",
  "referral.navigationBar.step3.primaryButtonText": "Finish and send referral",
  "referral.referralSent.referralSent": "Referral sent",
  "referral.referralSent.sentDescription": "The opportunity has been sent to the actor(s) and the e-mails are sent.",
  "referral.referralSent.archiveDescription": "You can archive the opportunity if you are done processing it.",
  "referral.referralSent.activityLogDescription": "You can still track the opportunity from the Activity Log.",
  "referral.referralSent.primaryButton": "Go to Archiving",
  "referral.referralSent.secondaryButton": "Add note",
  "referral.referralSent.tertiaryButton": "Back to the first step of Referral",
  "referral.sendReferral.sendReferralInfo": "The actor(s) will receive the opportunity via Flerbedriftsportalen and will be informed by e-mail.",
  "referral.sendReferral.sendReferralInfoWithCustomer": "The actor(s) will receive the opportunity via Flerbedriftsportalen and both the actor(s) and customer will be informed by e-mail.",
  "referral.sendReferral.referralError.header": "Referral failed",
  "to": "To: ",
  "opportunity.changeStatus": "Change status:",
  "opportunity.feedback.alsoReferredTo": "This inquiry was also referred to: ",
  "opportunity.feedback.correct.title": "Good! Are there other actors we also should have referred to?",
  "opportunity.feedback.correct.text": "Here you can choose other actors we also should have referred to. Feel free to share your thoughts about the referral. We cannot answer you feedback, but we use it to improve the referral process.",
  "opportunity.feedback.answerSent": "Answer sent",
  "opportunity.feedback.thankYou": "Thank you for your feedback!",
  "opportunity.feedback.forwardToAnotherActor": "Please forward this inquiry to another actor",
  "opportunity.table.filter.noMunicipality": "No municipality",
  "opportunity.addAdvisor.toastSuccess.title": "Advisor assigned",
  "opportunity.addAdvisor.toastSuccess.info": "The assigned advisors name will be shown",
  "opportunity.addAdvisor.email.toastSuccess.title": "E-mail notification sent",
  "opportunity.addAdvisor.email.toastSuccess.info": "The assigned advisor will receive an e-mail notification",
  "opportunity.addAdvisor.toastError.title": "Could not assign advisor",
  "opportunity.addAdvisor.toastError.info": "Try again. If the problem persists, contact us on support@enveiinn.no",
  "opportunity.addAdvisor.modal.title": "Assign advisor",
  "opportunity.addAdvisor.modal.infoText": "You can assign the opportunity to an advisor in your organization. The name of the advisor will be shown in the opportunity table. If you cannot find the advisor you can invite them to the portal.",
  "opportunity.addAdvisor.modal.invite": "Invite new users via ",
  "opportunity.addAdvisor.modal.searchPlaceholder": "Search for advisor",
  "opportunity.addAdvisor.addButton": "Assign to advisor",
  "opportunity.addAdvisor.notAssigned": "Not asigned",
  "opportunity.addAdvisor.sendEmail": "Send e-mail notification to the advisor",
  "advisor.label": "Advisor:",
  "advisor.tooltip": "Advisor",
  "advisor.currentlyAssigned": "Assigned advisor",
  "advisor.changeAdvisor": "Reassign advisor",
  "advisor.assignAdvisor": "Assign advisor",
  "opportunity.addAdvisor.dialog.sendEmailQuestion": "Do you want to send an e-mail notification to {{advisorName}}?",
  "opportunity.addAdvisor.dialog.advisorFallback": "the advisor",
  "opportunity.activeWithDeliveredServices": "Active opportunities with delivered services",

  "tabs.archive": "Archive",
  "tabs.active": "Active opportunities",

  "batchArchive.archive": "Archive",
  "batchArchive.notification.error.part1": "An ",
  "batchArchive.notification.error.error": "error",
  "batchArchive.notification.error.part2": " has occurred, try again later. If the error persists, contact us.",
  "batchArchive.toast.text.singular": "You can reopen this later",
  "batchArchive.toast.text.plural": "You can reopen these later",
  "batchArchive.toast.title.singular": "You have archived {{count}} opportunity",
  "batchArchive.toast.title.plural": "You have archived {{count}} opportunities",
  "batchArchive.modal.text.singular": "The opportunity will be archived, but can be reopened later if necessary.",
  "batchArchive.modal.text.plural": "The opportunities will be archived, but can be reopened later if necessary.",
  "batchArchive.modal.title": "Archive chose opportunities",
  "frontpage.notification.newOpportunities": "{{opportunityNumber}} unread opportunities",
  "frontpage.notification.newOpportunity": "1 unread opportunity",
  "frontpage.notification.opportunities": "{{opportunityNumber}} opportunities",
  "frontpage.notification.opportunity": "1 opportunity",
  "frontpage.actors": "Actors in",
  "frontpage.actorTotal": "{{count}} actors are registered in Flerbedrifsportalen as of",
  "frontpage.howTo.header": "How to handle a One Way In opportunity",
  "frontpage.howTo.evaluateReferral.header": "Evaluate if the opportunity is correct",
  "frontpage.howTo.evaluateReferral.text": "Read the opportunity and give feedback as to whether it is referred correctly to you.",
  "frontpage.howTo.referral.header": "Refer to other actors",
  "frontpage.howTo.referral.text": "Refer to other actors if the referral is also relevant for them. Recommend any services you feel are appropriate for the custoemr.",
  "frontpage.howTo.services.header": "Highlight your services",
  "frontpage.howTo.services.text": "Add your own services. Recommend them to customers. Mark the ones you'de delivered. This will make your services more visible for other actors.",
  "frontpage.howTo.memory.header": "Build common memory",
  "frontpage.howTo.memory.text": "Update the opportunity with how you helped the customer, so that others in the business supprt system can assist them in the best way possible.",
  "frontpage.countyServices.none": "No services have been registered in your county",
  "frontpage.statistics.recommended.total": "Total number of delivered services",

  "customerFollowUp.myServices": "My services ({{count}})",
  "customerFollowUp.goToMyServices": "Go to My services",
  "customerFollowup.cantFindService": "Can't find the service? Register it in Felles tjenestekatalog.",
  "customerFollowup.recommended": "Recommended",
  "customerFollowup.notRecommended": "Not recommended",
  "customerFollowUp.deliverService": "Deliver service",

  "customerFollowUp.toast.error.title": "An error has occurred",
  "customerFollowUp.toast.error.text": "Try again later. If the error persists, contact us.",

  "customerFollowUp.addNote.toast.success.title": "Note added",
  "customerFollowUp.addNote.toast.success.text": "You can find the note in the activity log.",
  "customerFollowUp.addNote.toast.error.title": "An error has occurred",
  "customerFollowUp.addNote.toast.error.text": "Try again later. If the error persists, please contact us.",
  "customerFollowUp.addNote.title": "Make note",
  "customerFollowUp.addNote.p1": "Here you can add information that is useful for yourself and others working on this opportunity. The note may contain:",
  "customerFollowUp.addNote.li1": "Communication with customers such as meetings, e-mails or phone calls.",
  "customerFollowUp.addNote.li2": "Recommendations or important clarifications with the customer.",
  "customerFollowUp.addNote.li3": "Suggestions for the next step for the customer.",
  "customerFollowUp.addNote.p2": "The note is saved in the activity log and contributes to shared memory and effective follow-up. Be clear and specific.",

  "customerFollowUp.deliveredServices.title": "Delivered services",
  "customerFollowUp.deliveredServices.p1": "Here you choose which services you have given the customer as part of the processing of the opportunity. These will be added to the activity log.",
  "customerFollowUp.deliveredServices.servicesDelivered": "Service delivered",
  "customerFollowUp.deliveredServices.delivered": "Delivered",
  "customerFollowUp.notDelivered": "Not delivered",
  "customerFollowUp.deliveredServices.modal.title": "Confirm that you have delivered the service",
  "customerFollowUp.deliveredServices.modal.p1": "What is the next step for the customer?",
  "customerFollowUp.deliveredServices.modal.p2": "All information will be added to the activity log and will help other actors that will process this opportunity.",
  "customerFollowUp.deliveredServices.modal.p3": "If another actor can help the customer, remember to refer the opportunity.",
  "customerFollowUp.deliveredServices.confirmDelivered": "Confirm delivered",
  "customerFollowUp.deliveredServices.toast.success.title": "Delivered service registered",
  "customerFollowUp.deliveredServices.toast.success.text": "Delivered service will be added to the activity log",

  "customerFollowUp.recommendServices.title": "Recommend your services via e-mail",
  "customerFollowUp.recommendServices.p1": "Here you can recommend your services to the customer.",
  "customerFollowUp.recommendServices.toast.success.title": "Recommendation sent",
  "customerFollowUp.recommendServices.modal.p1": "Auto-generated email that will be sent to the customer. The text you enter in the input field will be placed at the same place in the email.",
  "customerFollowUp.recommendServices.modal.emailPreview.textArea.placeholder": "Enter any relevant information here",
  "customerFollowUp.recommendServices.modal.p2": "This information will be added to the activity log and it will help other actors working with this opportunity.",
  "customerFollowUp.recommendServices.modal.button.primary": "Send recommendation",
  "customerFollowUp.recommendServices.alert.title": "New in the Service catalog",
  "customerFollowUp.recommendServices.alert.text": "Services can now include a short text to advertise them to customers. Edit your services to take advantage of this.",

  "customerFollowUp.recommendedServices.title": "Your services that other actors have recommended",
  "customerFollowUp.recommendedServices.p1": "These services have been recommended by other actors. Press “Deliver service” if you have delivered the service to the customer.",

  "referring.chosenActorForReferral": "Referral to:",
  "referring.servicesIn": "Services in",
  "referring.serviceDescription": "Description of service",
  "referring.deliveryTypes": "How the service is delivered",
  "referring.companyAge": "Required company age",
  "companyAge.UnderThreeYears": "Under 3 years",
  "companyAge.UnderFiveYears": "Under 5 years",
  "companyAge.OverFiveYears": "Over 5 years",
  "companyAge.RelevantForAllAges": "Relevant for all ages",
  "companyAge.Unknown": "Unknown",
  "referring.companySize": "Required company size",
  "companySize.Small": "Small (<50 man-years)",
  "companySize.Medium": "Medium (50-250 man-years)",
  "companySize.Large": "Large (>250 man-years)",
  "companySize.OtherCategoriesMayApply": "Other categories may apply",
  "companySize.Unknown": "Unknown",
  "deliveryType.Connecting": "Connecting",
  "deliveryType.Egenkapital": "Equity capital",
  "deliveryType.Fellesarrangementer": "Joint events",
  "deliveryType.Foredrag": "Lectures",
  "deliveryType.Garantier": "Guarantees",
  "deliveryType.Kurs": "Courses",
  "deliveryType.Lavrisikolaan": "Low-risk loans",
  "deliveryType.Orientering": "Information",
  "deliveryType.Prosjektarbeid": "Project work",
  "deliveryType.Publikasjon": "Publications",
  "deliveryType.Raadgivning": "Advisory services",
  "deliveryType.Risikolaan": "Risk loans",
  "deliveryType.Selvbetjening": "Self-service",
  "deliveryType.Tilskudd": "Grants",
  "deliveryType.Unknown": "Unknown",
  "referring.requirements": "Requirements",
  "referring.selectedServices": "Services you suggest for the actor:",
  "referring.servicesTable.selectedRowsSingular": "service selected",
  "referring.servicesTable.selectedRowsPlural": "services selected",
  "referring.servicesTable.showInfo": "Show service information",

  "referring.navigationBar.stepText.step0": "Choose the actor you want to refer to",
  "referring.navigationBar.stepText.step1": "Choose services that are relevant to the customer (optional)",
  "referring.navigationBar.stepText.step2": "Write a message to the actor who receives the referral",
  "referring.navigationBar.stepText.step3": "Send referral",

  "referring.navigationBar.stepSubText.step2": "You can also write an email to the customer",

  "review.addNote.success": "You'll find the note under \"Feedbacks\"",

  "connectCompany": "Connect company",
  "connectCompany.modal.description.part1": "You can connect the opportunity to a company if the customer has established a company. You need to know the company name to do this.",
  "connectCompany.modal.description.part2": "When the opportunity is connected to the company, you will get access to the company information.",
  "connectCompany.toast.success.title": "Company connected",
  "connectCompany.toast.error.title": "Could not connect the company",
  "connectCompany.toast.error.text": "Try again. If the problem persists, contact us at support@enveiinn.no.",

  "changeStatusDropdown.label": "Status:",
  "changeStatusDropdown.tooltip": "Status",

  "changeStatusModal.changeStatus": "Change status",
  "changeStatusModal.select.label": "Status",
  "changeStatusModal.select.placeholder": "Choose new status",
  "changeStatusModal.toast.success.title": "Status changed",
  "changeStatusModal.toast.error.title": "Could not change the status",
  "changeStatusModal.toast.error.text": "Please try again. If the problem persists, contact us at support@enveiinn.no.",
  "changeStatusModal.mailReminder.checkbox.text": "Send me a reminder by e-mail",
  "changeStatusModal.mailReminder.dateInput.label": "Reminder will be sent",
  "changeStatusModal.description.archive": "The opportunity will be archived, but can be re-opened later if necessary.",
  "changeStatusModal.description.reOpen": "The processing of the opportunity is resumed. Write a note with the reasoning. The note will be displayed in the Activity Log.",
  "changeStatusModal.description.followUpLater": "You can process the opportunity later. Write a note for future follow up. The note will be displayed in the Activity Log.",
  "changeStatusModal.currentStatus": "Current status",
  "nationWide": "Nationwide",
  "communication.sendEmail": "Send email",
  "communication.sendNewEmail": "Send new email",
  "communication.sendEmailToCustomer": "Send email to the customer",
  "communication.emailLabel": "Write a new email",
  "communication.emailThreadFallback.p1": "We are working on changing the sender address for emails sent from the Multi-company Portal. For now, the address is",
  "communication.emailThreadFallback.p2": "Customers cannot see previous messages in the email, but they can still reply directly to emails you have sent through the Multi-company Portal.",
  "communication.emailThreadFallback.p3": "We are continuously improving the solution. If you have feedback or questions, we would be happy to hear from you.",
  "communication.emailThreadFallback.p4": "Thank you for your patience!",
  "communication.newEmail.title": "Send a new email to the customer",
  "communication.newEmail.error.empty": "The email cannot be empty",
  "communication.newEmail.error.sendFailed": "Unable to send the email. Please try again later",
  "communication.newEmail.toast.title": "Email sent",
  "communication.newEmail.toast.text": "You will find it in “My inbox”",
  "statistics.statusMap": "Overview of Opportunity statuses",
  "statistics.serviceDeliveryMap": "Recommended & delivered services",
  "statistics.serviceDeliveryMap.delivered": "Delivered",
  "statistics.serviceDeliveryMap.recommended": "Recommended",
  "statistics.numDeliveredServices": "Number of delivered services",
  "statistics.numOptyForwarded": "Number of opportunities forwarded",
  "statistics.numOptyReceived": "Number of opportunities received",
  "statistics.numOptyReceivedCorrectly": "Number of opportunities received correctly",
  "sponsors.DFD": "Ministry of Digitalisation and Public Governance",
  "sponsors.FIN": "Ministry of Finance",
  "sponsors.KDD": "Ministry of Local Government and Regional Development",
  "sponsors.KLD": "Ministry of Climate and Environment",
  "sponsors.KUD": "Ministry of Culture and Equality",
  "sponsors.KD": "Ministry of Education and Research",
  "sponsors.LMD": "Ministry of Agriculture and Food",
  "sponsors.NFD": "Ministry of Trade, Industry and Fisheries",
  "sponsors.Norad": "Norad",
  "sponsors.Counties": "Counties",
  "sponsors.OED": "Ministry of Energy",
  "sponsors.SD": "Ministry of Transport",
  "sponsors.UD": "Ministry of Foreign Affairs",
  "sponsors.Unknown": "Unknown",

  "opportunityBoard.recommendServicesModal.title": "Recommend own services",
  "opportunityBoard.recommendServicesModal.description": "Add one or more services from the list",
  "opportunityBoard.noServicesModal.title": "You have no services",
  "opportunityBoard.noServicesModal.description": "To use this feature, you must create a service.",
  "opportunityBoard.deliverServicesModal.title": "Deliver own services",
  "opportunityBoard.deliverServicesModal.description": "Select one or more services from the list",
  "opportunityBoard.deliverServicesModal.primaryButton": "Mark as delivered",
  "opportunityBoard.deliverServicesModal.dateLabel": "When was the service(s) delivered?",

  "errorMessage.NoServicesSelected": "You must select at least one service.",
  "errorMessage.SomethingWentWrong": "An error occurred. Please try again later.",
  "errorMessage.FieldEmpty": "The field cannot be empty",

  "toasts.activityLogUpdated": "The activity log has been updated",
  "toasts.serviceDelivery.success.title": "The services have been marked as delivered",

  "tooltip.addAdvisor": "Add advisor",
  "tooltip.changeAdvisor": "Change advisor",
  "recommended": "Recommended",

  "noFiltersAvailable": "No filters available",
  "filterByKeyword": "Filter by keyword",

  "refer.dialog.ariaLabel": "Refer the opportunity",
  "refer.dialog.selectActor": "Choose the actor you want to refer to",
  "refer.validation.noActorChosen": "You must select an actor to refer to",
  "refer.dialog.actorAlreadyHasOpportunity": "<bold>{{name}}</bold> already has the inquiry. Choose one or more services to recommend.",
  "refer.dialog.chooseService": "Choose service at <bold>{{name}}</bold> (optional)",
  "refer.validation.noServiceChosen": "You must select at least one service",
  "refer.validation.messageEmpty": "The email cannot be empty",
  "refer.dialog.sendReferral": "Send referral",
  "refer.dialog.writeMessageToActor": "Send email to {{name}}",
  "refer.dialog.customerEmailPrompt.title": "Do you also want to send an email to the customer?",
  "refer.dialog.customerEmailPrompt.description": "Here you can inform the customer that their inquiry has been forwarded",
  "refer.dialog.writeMessageToCustomer": "Send email to customer",
  "refer.dialog.archivePrompt.title": "Do you want to archive the inquiry?",
  "refer.dialog.archivePrompt.error": "Could not archive. Please try again later.",

  "changeStatusDropdown.note": "Note",
  "changeStatusDropdown.noteIsRequired": "Note is required",
  "changeStatusDropdown.changingStatus": "Changing status",
  "changeStatusDropdown.newStatus": "New status:"
}
